import React from "react";

interface QuickStartListProps {
    children: React.ReactNode;
}

/**
 * Wrapper component for quick start content that applies consistent styling.
 * Replaces the .quick-start-ol CSS class with Tailwind utilities.
 */
const QuickStartList: React.FC<QuickStartListProps> = ({ children }) => {
    return (
        <div className="m-4 text-base [&_li]:my-3">
            {children}
        </div>
    );
};

export default QuickStartList;
